import { useState } from "react";

import { useContainer } from "@contexts/container-context";

import { ENTRY_TYPES } from "../ai-curriculum.constants";
import { AiEntryCard } from "../components";

import "./ai-entry-point.step.scss";

export const AiEntryPointStep = ({ orgCode, onSelect, onError }) => {
  const { aiCurriculumService } = useContainer();
  const [pending, setPending] = useState(null);

  const handleSelect = async (entryType) => {
    setPending(entryType);
    try {
      const response = await aiCurriculumService.createSession(
        orgCode,
        entryType
      );
      onSelect({ entryType, sessionId: response.sessionId });
    } catch (error) {
      // 401 = no access to the target org — don't suggest retrying.
      onError(
        error?.status === 401
          ? "You don't have access to this classroom's organization. Contact your administrator if you believe this is a mistake."
          : "We couldn't start a new session. Please try again."
      );
    } finally {
      setPending(null);
    }
  };

  return (
    <div className="ai-entry-point-step">
      <header className="ai-entry-point-step__header">
        <h2>What should we base your recommendations on?</h2>
      </header>

      <div className="ai-entry-point-step__cards">
        <AiEntryCard
          image="/images/ai-curriculum/short.png"
          title="State Standards"
          description="Pick a state and profession to align your course to official CTE standards."
          buttonLabel="Get Started"
          buttonIcon="arrow-right"
          loading={pending === ENTRY_TYPES.STATE_STANDARDS}
          onClick={() => handleSelect(ENTRY_TYPES.STATE_STANDARDS)}
        />
        <AiEntryCard
          image="/images/ai-curriculum/syllabus.png"
          title="Upload Syllabus"
          description="Upload a PDF, DOCX, JPG, or PNG to extract standards automatically."
          buttonLabel="Upload"
          buttonIcon="upload"
          loading={pending === ENTRY_TYPES.SYLLABUS_UPLOAD}
          onClick={() => handleSelect(ENTRY_TYPES.SYLLABUS_UPLOAD)}
        />
        <AiEntryCard
          image="/images/ai-curriculum/short.png"
          title="Quick Start"
          description="Fill in a short form and get instant recommendations."
          buttonLabel="Get Started"
          buttonIcon="arrow-right"
          loading={pending === ENTRY_TYPES.QUICK_START}
          onClick={() => handleSelect(ENTRY_TYPES.QUICK_START)}
        />
      </div>
    </div>
  );
};
